export const tableHelpers = {
    data() {
        return {
            tableColumns: [{
                    title: 'Organización',
                    type: 'custom-html',
                    key: 'org',
                    modifier: (item) => {
                        return item ? "Unidad Técnica - "+ item.canton.name  : 'Matriz';
                    }
                },
                // {
                //     title: 'Localización',
                //     type: 'text',
                //     key: 'location',
                // },
                /* {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                }, */
                {
                    title: 'Categoría',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Campo de calibración',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Magnitud y Submagnitud',
                    type: 'custom-html',
                    key: 'level_5',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Rango de Medida',
                    type: 'custom-html',
                    key: 'level7',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Incertidumbre',
                    type: 'custom-html',
                    key: 'level8',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Instrumentos',
                    type: 'custom-html',
                    key: 'level_6_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Método Interno',
                    type: 'custom-html',
                    key: 'level9',
                    modifier: (item) => {
                        return item;
                    },
                },
                {
                    title: 'Método Referencia (revisión/edición) ',
                    type: 'custom-html',
                    key: 'level10',
                    modifier: (item) => {
                        return item;
                    },
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}